import {
    AI_TRANSFORM_STREAM_DONE,
    AI_TRANSFORM_STREAM_ERROR,
    RESET_AI_TRANSFORM,
    TRANSFORM_RICH_TEXT_SUCCESS,
} from './aiTransform.type';

/**
 * `streamStatus` lifecycle:
 *   'idle'      → no transform running (initial / after reset)
 *   'streaming' → HTTP succeeded, conversationId issued, chunks may be flowing
 *   'done'      → ai:done received
 *   'error'     → ai:error received
 *
 * `transform.conversationId` is the correlation id; consumers wire it into
 * `useAiSessionNoteStream` (the streaming hook is generic — same socket
 * events, just a different conversationId).
 */
const initialState = {
    /** `{ conversationId }` from POST response, or null. */
    transform: null,
    streamStatus: 'idle',
};

export const aiTransformReducer = (state = initialState, action) => {
    switch (action.type) {
        case TRANSFORM_RICH_TEXT_SUCCESS:
            return { ...state, transform: action.payload, streamStatus: 'streaming' };
        case AI_TRANSFORM_STREAM_DONE:
            return { ...state, streamStatus: 'done' };
        case AI_TRANSFORM_STREAM_ERROR:
            return { ...state, streamStatus: 'error' };
        case RESET_AI_TRANSFORM:
            return initialState;
        default:
            return state;
    }
};
